import { render, staticRenderFns } from "./ManageGroupsDialog.vue?vue&type=template&id=ba786400&scoped=true"
import script from "./ManageGroupsDialog.vue?vue&type=script&lang=js"
export * from "./ManageGroupsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba786400",
  null
  
)

export default component.exports